import { render, staticRenderFns } from "./ValidateBrandFilters.vue?vue&type=template&id=3edb585f"
import script from "./ValidateBrandFilters.vue?vue&type=script&lang=ts"
export * from "./ValidateBrandFilters.vue?vue&type=script&lang=ts"
import style0 from "./ValidateBrandFilters.vue?vue&type=style&index=0&id=3edb585f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports